import { Sheet } from '@/components/ui';
import { useAppDispatch, useAppSelector } from '@/config/store';
import { IEdoChat } from '@/shared/model/edo-chat.model';
import { IEdoChatParticipation } from '@/shared/model/edo-chat-participation.model';
import { ChatState, getUserParticipations, openChatWindow } from '@/shared/reducers/chat.reducer';
import { MessageCircle, X } from 'lucide-react';
import ChatList from 'pages/chat/components/ChatList';
import { CreateGroup } from 'pages/chat/components/CreateGroup';
import ChatHeaderBar from 'pages/chat/components/HeaderBar';
import { useEffect, useState } from 'react';

interface ChatDrawerProps {
    open: boolean;
    onClose: () => void;
}

const ChatDrawer = (props: ChatDrawerProps) => {
    const dispatch = useAppDispatch();
    const { participations } = useAppSelector<ChatState>(state => state.chat);
    const [editDialog, setEditDialog] = useState<{ open: boolean; entity: IEdoChat | null; }>({ open: false, entity: null });

    const { open, onClose: handleClose } = props;

    const handleSelectParticipation = (participation: IEdoChatParticipation) => {
        if (participation && participation.chat?.id != null) {
            dispatch(openChatWindow(participation.chat.id));
            handleClose();
        }
    };

    useEffect(() => {
        const getParticipations = () => {
            dispatch(
                getUserParticipations({
                    page: 0,
                    size: 1000,
                    sort: "id:ASC",
                })
            );
        };

        getParticipations();
    }, [dispatch]);

    return (
        <>
            <Sheet open={open} onClose={handleClose} side="right" width={320}>
                <div className="flex h-full flex-col">
                    <div className="flex shrink-0 items-center justify-between border-b border-[var(--color-mockup-border)] p-4">
                        <div className="flex items-center gap-2">
                            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary">
                                <MessageCircle className="h-5 w-5" />
                            </span>
                            <div>
                                <h2 className="font-heading text-base font-bold leading-tight text-[var(--color-mockup-text)]">
                                    Messaggi
                                </h2>
                                <p className="text-xs text-[var(--color-mockup-text-light)]">
                                    Chat e gruppi
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={handleClose}
                            aria-label="Chiudi pannello"
                            className="inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-[var(--color-mockup-text-mid)] transition-colors hover:bg-primary/10 hover:text-primary"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    </div>
                    <div className="shrink-0 border-b border-[var(--color-mockup-border)]">
                        <ChatHeaderBar onEdit={(chat) => setEditDialog({ open: true, entity: chat })} showAccount={false} />
                    </div>
                    <div className="min-h-0 flex-1 overflow-y-auto">
                        {participations.length === 0 ? (
                            <p className="px-4 py-8 text-center text-sm text-[var(--color-mockup-text-light)]">
                                Nessuna conversazione. Inizia una nuova chat dalla barra di ricerca.
                            </p>
                        ) : (
                            <ChatList
                                participations={participations}
                                onSelectParticipation={handleSelectParticipation}
                            />
                        )}
                    </div>
                </div>
            </Sheet>
            <CreateGroup
                gruppo={editDialog.entity}
                open={editDialog.open}
                handleClose={() => setEditDialog({ open: false, entity: null })}
            />
        </>
    );
};

export default ChatDrawer;
